/* Clara — scripts propios (vanilla, sin librerías). */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = null;

  /* ---- Reveals: un único IntersectionObserver compartido ---- */
  function initReveals(root) {
    var els = (root || document).querySelectorAll('.cl-reveal:not(.cl-visible)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduceMotion) {
      els.forEach(function (el) { el.classList.add('cl-visible'); });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('cl-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    }
    els.forEach(function (el) { observer.observe(el); });
  }

  /* ---- Pestañas de la portada ---- */
  function initTabs(root) {
    (root || document).querySelectorAll('[data-cl-tabs]').forEach(function (wrap) {
      if (wrap.__clReady) return;
      wrap.__clReady = true;
      var tabs = Array.prototype.slice.call(wrap.querySelectorAll('[role="tab"]'));
      var panels = Array.prototype.slice.call(wrap.querySelectorAll('[role="tabpanel"]'));
      function select(tab) {
        tabs.forEach(function (t, i) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          if (panels[i]) {
            panels[i].hidden = !on;
            if (on) initReveals(panels[i]);
          }
        });
      }
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(tab); });
        tab.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
          if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
          if (next) { e.preventDefault(); select(next); next.focus(); }
        });
      });
    });
  }

  /* ---- Demo "Tidy up": del desorden al orden ---- */
  function initTidy(root) {
    (root || document).querySelectorAll('[data-cl-tidy]').forEach(function (el) {
      if (el.__clReady) return;
      el.__clReady = true;
      var btn = el.querySelector('[data-cl-tidy-toggle]');
      var caption = el.querySelector('[data-cl-tidy-caption]');
      var msgMess = el.getAttribute('data-mess') || '';
      var msgTidy = el.getAttribute('data-tidy') || '';
      function setState(tidy) {
        el.classList.toggle('is-tidy', tidy);
        if (btn) btn.setAttribute('aria-pressed', tidy ? 'true' : 'false');
        if (caption) caption.innerHTML = tidy ? msgTidy : msgMess;
      }
      setState(false);
      if (btn) btn.addEventListener('click', function () { setState(!el.classList.contains('is-tidy')); });
      if ('IntersectionObserver' in window && !reduceMotion) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              io.disconnect();
              setTimeout(function () { setState(true); }, 1100);
            }
          });
        }, { threshold: 0.55 });
        io.observe(el);
      } else {
        setState(true);
      }
    });
  }

  /* ---- Ordenar la colección ---- */
  function initSort(root) {
    (root || document).querySelectorAll('[data-cl-sort]').forEach(function (sel) {
      if (sel.__clReady) return;
      sel.__clReady = true;
      sel.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sel.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  /* ---- Página de producto: galería, variantes y cantidad ---- */
  function initProduct(root) {
    (root || document).querySelectorAll('[data-cl-product]').forEach(function (wrap) {
      if (wrap.__clReady) return;
      wrap.__clReady = true;

      var dataEl = wrap.querySelector('[data-cl-variants]');
      var variants = [];
      try { variants = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (e) { variants = []; }

      var idInput = wrap.querySelector('input[name="id"]');
      var priceNow = wrap.querySelector('[data-cl-price]');
      var priceWas = wrap.querySelector('[data-cl-price-was]');
      var priceSave = wrap.querySelector('[data-cl-price-save]');
      var addBtn = wrap.querySelector('[data-cl-add]');
      var addLabel = wrap.querySelector('[data-cl-add-label]');
      var mainImg = wrap.querySelector('[data-cl-main]');
      var thumbs = Array.prototype.slice.call(wrap.querySelectorAll('[data-cl-thumb]'));
      var labels = wrap.querySelectorAll('[data-cl-option-value]');
      var current = Math.max(0, thumbs.findIndex(function (t) { return t.getAttribute('aria-current') === 'true'; }));
      var texts = {
        add: wrap.getAttribute('data-add-text') || 'Add to cart',
        sold: wrap.getAttribute('data-sold-text') || 'Sold out'
      };

      function showThumb(i) {
        if (!mainImg || !thumbs.length) return;
        current = (i + thumbs.length) % thumbs.length;
        var btn = thumbs[current];
        var src = btn.getAttribute('data-src');
        thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === current ? 'true' : 'false'); });
        if (!src || mainImg.getAttribute('src') === src) return;
        mainImg.classList.add('cl-swap');
        setTimeout(function () {
          mainImg.setAttribute('src', src);
          mainImg.setAttribute('srcset', btn.getAttribute('data-srcset') || '');
          mainImg.setAttribute('alt', btn.getAttribute('data-alt') || '');
          mainImg.classList.remove('cl-swap');
        }, reduceMotion ? 0 : 180);
        if (btn.scrollIntoView) { try { btn.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' }); } catch (e) { /* nada */ } }
      }

      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { showThumb(i); }); });
      var prev = wrap.querySelector('[data-cl-prev]');
      var next = wrap.querySelector('[data-cl-next]');
      if (prev) prev.addEventListener('click', function () { showThumb(current - 1); });
      if (next) next.addEventListener('click', function () { showThumb(current + 1); });

      function currentOptions() {
        var chosen = [];
        wrap.querySelectorAll('[data-cl-option] input:checked').forEach(function (i) { chosen.push(i.value); });
        return chosen;
      }
      function findVariant(chosen) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i], ok = true;
          for (var j = 0; j < chosen.length; j++) {
            if (v.options[j] !== chosen[j]) { ok = false; break; }
          }
          if (ok) return v;
        }
        return null;
      }

      function onChange() {
        var chosen = currentOptions();
        labels.forEach(function (l) {
          var idx = parseInt(l.getAttribute('data-cl-option-value'), 10);
          if (chosen[idx] !== undefined) l.textContent = chosen[idx];
        });
        var v = findVariant(chosen);
        if (!v) return;
        if (idInput) idInput.value = v.id;
        if (priceNow) priceNow.textContent = v.price;
        if (priceWas) {
          if (v.compare_at) { priceWas.textContent = v.compare_at; priceWas.hidden = false; }
          else { priceWas.hidden = true; }
        }
        if (priceSave) priceSave.hidden = !v.compare_at;
        if (addBtn) {
          if (v.available) { addBtn.removeAttribute('disabled'); addBtn.removeAttribute('aria-disabled'); }
          else { addBtn.setAttribute('disabled', 'disabled'); }
          if (addLabel) addLabel.textContent = v.available ? texts.add : texts.sold;
        }
        var pay = wrap.querySelector('.shopify-payment-button');
        if (pay) pay.style.display = v.available ? '' : 'none';
        if (v.image) {
          var idx = thumbs.findIndex(function (t) { return t.getAttribute('data-media-id') === String(v.image); });
          if (idx > -1) showThumb(idx);
        }
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) { /* sin historial: no pasa nada */ }
      }
      wrap.querySelectorAll('[data-cl-option] input').forEach(function (i) { i.addEventListener('change', onChange); });

      var qty = wrap.querySelector('[data-cl-qty]');
      if (qty) {
        var qInput = qty.querySelector('input');
        qty.querySelectorAll('[data-cl-qty-step]').forEach(function (b) {
          b.addEventListener('click', function () {
            var n = parseInt(qInput.value, 10) || 1;
            n += parseInt(b.getAttribute('data-cl-qty-step'), 10);
            qInput.value = Math.max(1, Math.min(99, n));
          });
        });
      }
    });
  }

  /* ---- Formulario de contacto: "Other" pide el motivo ---- */
  function initContact(root) {
    (root || document).querySelectorAll('[data-cl-reason]').forEach(function (sel) {
      if (sel.__clReady) return;
      sel.__clReady = true;
      var form = sel.closest('form');
      var wrap = form && form.querySelector('[data-cl-other-wrap]');
      var input = form && form.querySelector('[data-cl-other-input]');
      var other = (sel.getAttribute('data-other') || '').toLowerCase();
      function sync() {
        var on = !!other && sel.value.toLowerCase() === other;
        if (wrap) wrap.hidden = !on;
        if (input) { input.disabled = !on; input.required = on; if (!on) input.value = ''; }
      }
      sel.addEventListener('change', sync);
      sync();
      if (form) {
        form.addEventListener('submit', function (e) {
          if (form.checkValidity && !form.checkValidity()) {
            e.preventDefault();
            var bad = form.querySelector(':invalid');
            if (bad) { bad.focus(); if (bad.reportValidity) bad.reportValidity(); }
          }
        });
      }
    });
  }

  /* ---- Pop-up de bienvenida (nombre + correo por un descuento) ---- */
  function initPopup() {
    var root = document.querySelector('[data-cl-popup]');
    if (!root || root.__clReady) return;
    root.__clReady = true;
    if (window.Shopify && window.Shopify.designMode) return;
    var DONE = 'cl_welcome_done', SEEN = 'cl_welcome_seen';
    function get(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
    function set(k, v) { try { window.localStorage.setItem(k, v); } catch (e) { /* sin almacenamiento */ } }
    var tab = document.querySelector('[data-cl-pop-tab]');
    var form = root.querySelector('form');
    var err = root.querySelector('[data-cl-pop-error]');
    var states = root.querySelectorAll('[data-cl-pop-state]');
    var opened = false, lastFocus = null;

    function show(name) {
      states.forEach(function (s) { s.hidden = s.getAttribute('data-cl-pop-state') !== name; });
    }
    function open(name) {
      if (opened) return;
      opened = true;
      lastFocus = document.activeElement;
      show(name);
      root.hidden = false;
      root.classList.add('is-open');
      var first = root.querySelector('[data-cl-pop-state]:not([hidden]) input, [data-cl-pop-state]:not([hidden]) a, [data-cl-pop-state]:not([hidden]) button');
      if (first && first.focus) { try { first.focus({ preventScroll: true }); } catch (e) { /* nada */ } }
    }
    function close() {
      if (!opened) return;
      opened = false;
      root.classList.remove('is-open');
      root.hidden = true;
      set(SEEN, String(Date.now()));
      if (tab) { tab.hidden = false; tab.classList.add('is-visible'); }
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) { /* nada */ } }
    }
    root.querySelectorAll('[data-cl-pop-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    if (tab) tab.addEventListener('click', function () { open(get(DONE) ? 'dup' : 'form'); });

    var copy = root.querySelector('[data-cl-pop-copy]');
    if (copy) copy.addEventListener('click', function () {
      var code = root.getAttribute('data-code') || '';
      function ok() { copy.textContent = 'Copied'; }
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(ok, ok); else ok();
    });

    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var name = form.querySelector('[name="contact[first_name]"]').value.trim();
      var mail = form.querySelector('[name="contact[email]"]').value.trim();
      var consent = form.querySelector('[data-cl-pop-consent]');
      var msg = root.getAttribute('data-error') || '';
      if (!name || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mail) || (consent && !consent.checked)) {
        if (err) err.textContent = err.getAttribute('data-msg') || 'Please enter a valid name and email and accept the box.';
        return;
      }
      if (get(DONE)) { show('dup'); return; }
      if (err) err.textContent = '';
      var btn = form.querySelector('button[type="submit"]');
      if (btn) btn.setAttribute('aria-disabled', 'true');
      fetch(form.getAttribute('action') || '/contact', { method: 'POST', body: new FormData(form), headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' })
        .then(function (r) {
          if (r.url && r.url.indexOf('challenge') > -1) { window.location.href = r.url; return; }
          if (r.ok && r.url && r.url.indexOf('customer_posted=true') > -1) { set(DONE, String(Date.now())); show('ok'); try { document.dispatchEvent(new CustomEvent('cl:lead')); } catch (e) { /* nada */ } }
          else if (err) err.textContent = err.getAttribute('data-msg') || 'Something went wrong. Please try again.';
        })
        .catch(function () { if (err) err.textContent = err.getAttribute('data-msg') || 'Something went wrong. Please try again.'; })
        .then(function () { if (btn) btn.removeAttribute('aria-disabled'); });
    });

    /* ¿cuándo se abre solo? una vez cada 3 días y nunca si ya reclamó la oferta */
    var done = get(DONE), seen = parseInt(get(SEEN) || '0', 10);
    var recentlySeen = seen && (Date.now() - seen) < 3 * 24 * 3600 * 1000;
    if (done || recentlySeen) { if (tab) { tab.hidden = false; tab.classList.add('is-visible'); } return; }
    var delay = (parseInt(root.getAttribute('data-delay'), 10) || 8) * 1000;
    var timer = setTimeout(function () { open('form'); }, delay);
    if (root.getAttribute('data-exit') === 'true' && window.matchMedia && window.matchMedia('(pointer: fine)').matches) {
      document.addEventListener('mouseout', function onOut(e) {
        if (e.clientY <= 0 && !e.relatedTarget) { clearTimeout(timer); document.removeEventListener('mouseout', onOut); open('form'); }
      });
    }
  }

  function initAll(root) {
    initReveals(root);
    initTabs(root);
    initTidy(root);
    initSort(root);
    initProduct(root);
    initContact(root);
    initPopup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  /* El editor de Shopify recarga secciones sueltas: reinicializamos. */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
